import { formatCurrencyShortForm, roundToDecimals, formatCurrency } from '@/utils/storage'
import { Box, IconButton, Paper, Skeleton, Tooltip, Typography } from '@mui/material'
import InfoIcon from '@/assets/info-icon.svg?react'
import TrendDownIcon from '@/assets/trend-down-red-icon.svg?react'
import TrendUpIcon from '@/assets/trend-up-green-icon.svg?react'
import StatsIcon from '@/assets/stats-icon.svg'

interface Props {
  title: string
  recentValue: number
  pastValue?: number
  growth?: number
  isLocked?: boolean
  icon?: string
  isLoading?: boolean
}

const MetricCard = ({
  title,
  recentValue,
  pastValue,
  growth,
  isLocked = false,
  icon = StatsIcon,
  isLoading = false,
}: Props) => {
  if (isLoading) {
    return (
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={100}>
        <Skeleton variant="rounded" width={370} height={100} sx={{ borderRadius: 4 }} />
      </Box>
    )
  }
  return (
    <Paper
      sx={{
        width: '100%',
        minHeight: 100,
        p: { xs: 0.5, sm: 2 },
        bgcolor: 'rgba(223, 202, 114, 0.2)',
        borderRadius: 4,
      }}
    >
      <Box display={'flex'} alignItems={'center'}>
        <img src={icon} />
        <Typography fontWeight={600} variant="h6" sx={{ color: '#382A02', fontSize: { xs: 12, sm: 20 } }}>
          {title}
        </Typography>
        <Tooltip placement="top-end" title={title}>
          <IconButton>
            <InfoIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <Box position={'relative'}>
        <Box
          position={'absolute'}
          sx={{
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.4)',
            opacity: isLocked ? 1 : 0,
            filter: isLocked ? 'blur(3px)' : 'none',
            zIndex: isLocked ? 1 : 0,
          }}
        />
        <Box
          position={'absolute'}
          sx={{
            flex: 1,
            flexDirection: { xs: 'column', sm: 'row' },
            width: '100%',
            filter: isLocked ? 'blur(8px)' : 'none',
            opacity: isLocked ? 0.5 : 1,
            zIndex: isLocked ? 1 : 0,
          }}
          display={'flex'}
          justifyContent={'space-between'}
          alignItems={'flex-end'}
        >
          <Tooltip title={recentValue.toLocaleString('id-ID')}>
            <Typography
              fontSize={{ xs: 20, sm: 28 }}
              fontWeight={600}
              sx={{ paddingLeft: { xs: 1, sm: 0 }, width: { xs: '100%', sm: 'auto' }, textAlign: 'left' }}
            >
              {formatCurrencyShortForm(roundToDecimals(recentValue, 3))}
            </Typography>
          </Tooltip>

          <Tooltip
            placement="bottom-end"
            // sx={{ width: '100%' }}
            title={formatCurrency(roundToDecimals(pastValue, 3))}
          >
            {growth ? (
              <Paper sx={{ display: 'flex', alignItems: 'center', px: 1, gap: 1, borderRadius: 2 }}>
                {growth > 0 ? <TrendUpIcon /> : <TrendDownIcon />}
                <Typography sx={{ color: growth > 0 ? 'green' : 'red', fontSize: { xs: 12, sm: 16 } }}>
                  {growth} %
                </Typography>
              </Paper>
            ) : null}
          </Tooltip>
        </Box>
      </Box>
    </Paper>
  )
}

export default MetricCard
